module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ba9d714c9d47b7bee049487dd4cacfef.png";